// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B_tJ","questions":"styles_questions__dKBmz","footer":"styles_footer__1_fSo"};